import { type FC } from 'react';
interface FormStatusProps {
    children: React.ReactNode;
    type: 'info' | 'warning' | 'error' | 'success';
}

const FormStatus: FC<FormStatusProps> = ({ children, type='info' }) => {
    return (
        <div className="Form__Status">
            <div
                role="alert"
                aria-live="polite"
                className={`Form__Status__Message Form__${type}__Message`}
                data-f-form-statusmessage=""
            >
                <p>{children}</p>
            </div>
        </div>
    );
};

export default FormStatus;
